import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { BePadraoImportacaoCartao } from 'src/app/models/BePadraoImportacaoCartao';

export interface CsvConfig {
  colunaDescricao: string;
  colunaValor: string;
  colunaData: string;
  formatoData: string;
  formatoValor: string;
  delimitador: string;
  arquivo: File | null;
}

@Component({
  selector: 'app-dialog-csv-config',
  templateUrl: './dialog-csv-config.component.html',
  styleUrls: ['./dialog-csv-config.component.css']
})
export class DialogCsvConfigComponent implements OnInit {
  public padraoSelecionado: BePadraoImportacaoCartao | null = null;
  public padroes: BePadraoImportacaoCartao[] = [];
  public arquivo: File | null = null;
  public nomeArquivo: string = '';
  public carregando: boolean = false;

  public constructor(
    public dialogRef: MatDialogRef<DialogCsvConfigComponent>,
    private httpClient: HttpClient
  ) { }

  public ngOnInit(): void {
    this.carregarPadroes();
  }

  private carregarPadroes(): void {
    this.carregando = true;
    this.httpClient.get<BePadraoImportacaoCartao[]>('/api/PadraoImportacaoCartao').subscribe({
      next: (padroes) => {
        this.padroes = padroes;
        this.carregando = false;
      },
      error: (err) => {
        console.error('Erro ao carregar padrões:', err);
        this.carregando = false;
      }
    });
  }

  public onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (file && file.name.toLowerCase().endsWith('.csv')) {
      this.arquivo = file;
      this.nomeArquivo = file.name;
    } else {
      this.arquivo = null;
      this.nomeArquivo = '';
      alert('Por favor, selecione um arquivo CSV válido.');
    }
  }

  public isValid(): boolean {
    return !!(this.padraoSelecionado && this.arquivo);
  }

  public confirmar(): void {
    if (this.isValid() && this.padraoSelecionado) {
      const config: CsvConfig = {
        colunaDescricao: this.padraoSelecionado.noColunaDescricao,
        colunaValor: this.padraoSelecionado.noColunaValor,
        colunaData: this.padraoSelecionado.noColunaData,
        formatoData: this.padraoSelecionado.dsFormatoData,
        formatoValor: this.padraoSelecionado.dsFormatoValor,
        delimitador: this.padraoSelecionado.dsDelimitador,
        arquivo: this.arquivo
      };
      this.dialogRef.close(config);
    }
  }

  public cancelar(): void {
    this.dialogRef.close(null);
  }
}
